/**
 * Layout dimension constants for TeamCreateDialog components.
 * Used for flex-basis calculations in both styled-components and compiled CSS.
 */

// Image section flex-basis values
export const IMAGE_SECTION_WIDTH_WIDE = 344;
export const IMAGE_SECTION_WIDTH_REGULAR = 280;

// Team data section flex-basis values
export const TEAM_DATA_SECTION_WIDTH_WIDE = 360;
export const TEAM_DATA_SECTION_WIDTH_REGULAR = 300;
